import React from 'react';
import { FaHeart } from 'react-icons/fa';
import './common.css';

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader-content">
        <FaHeart className="loader-icon" />
        <div className="loader-spinner"></div>
        <p>Chargement...</p>
      </div>
    </div>
  );
};

export default Loader;